import './AdsTxtSection.less';
import React from 'react';
import SectionCompetitorResults from '../../shared/SectionCompetitorResults';
import SectionMessage from '../../shared/SectionMessage';
import SectionTitle from '../../shared/SectionTitle';
import SectionTooltip from '../../shared/SectionTooltip';
import InlineModal from '../../shared/InlineModal';
import HowToFix from '../../shared/HowToFix';
import { SectionProps } from '../../types';

type AdsTxtInvalidRecordsProps = {
    title: string;
    type: string;
    records: any[];
};

function AdsTxtInvalidRecords({ title, type, records }: AdsTxtInvalidRecordsProps) {
    return (
        <div className="invalid-ads-records">
            {title && (
                <h3>
                    {title}({records.length}):
                </h3>
            )}
            <ul>
                {records.map((record, idx) => {
                    return (
                        <li key={idx}>
                            <span>{`line ${record['pos']}: `}</span>

                            <code className={type === 'error' ? 'error' : ''}>{record['content']}</code>

                            <div>{record['message']}</div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default function AdsTxtSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className={`report-element ${result.status}`}
        >
            <SectionTitle
                title={title}
                status={result.status}
                passRate={passRate}
            />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {['warning', 'failed'].includes(result.status) && (
                    <>
                        <div className="description-meta">
                            {(result.errors || result.warnings) && (
                                <InlineModal
                                    openLabel="See results list"
                                    modalTitle="Full list of invalid records"
                                    closeLabel="Close"
                                >
                                    {result.errors.length > 0 && (
                                        <AdsTxtInvalidRecords
                                            type="error"
                                            title="Errors"
                                            records={result.errors}
                                        />
                                    )}

                                    {result.warnings.length > 0 && (
                                        <AdsTxtInvalidRecords
                                            type="warning"
                                            title="Warnings"
                                            records={result.warnings}
                                        />
                                    )}
                                </InlineModal>
                            )}
                        </div>

                        {result.how_to_fix && (
                            <HowToFix
                                title={title}
                                howToFix={result.how_to_fix}
                                howToFixVideo={result.how_to_fix_video}
                            />
                        )}
                    </>
                )}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}
